import React from 'react';
import useAnalytics from 'helpers/useAnalytics';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import VerifiedUserRoundedIcon from '@material-ui/icons/VerifiedUserRounded';
import Link from '@material-ui/core/Link';

function SecurityNotice() {
  const classes = useStyles();
  const analytics = useAnalytics();

  const handleNavigate = () => {
    analytics.track('Data Sync - Learn More About security link Clicked', {
      category: 'AD - Directories',
    });
  };

  return (
    <Paper className={classes.root}>
      <VerifiedUserRoundedIcon
        className={classes.icon}
        color="secondary"
        titleAccess="Security Icon"
      />
      <Typography className={classes.content}>
        We keep your employee data safe and never share your data with third parties by undergoing
        regular security audits and adhering to strict data redundancy, encryption, and segmentation
        policies.{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.justsift.com/security"
          color="secondary"
          onClick={handleNavigate}
        >
          {' '}
          Learn more about how we keep your data secure
        </Link>
        .
      </Typography>
    </Paper>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 1134,
    minHeight: 76,
    marginBottom: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    height: 42,
    width: 42,
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(1.25),
  },
  content: {
    maxWidth: 991,
  },
}));

export default SecurityNotice;
